import { Company } from './company';
import { ProductXBZ } from './product-xbz';
import { Service } from './service';
import { Team } from './team';

export enum BudgetStatus {
  CREATED = 'created',
  CANCELLED = 'cancelled',
  STARTED = 'started',
}

export type Budget = {
  id: number;
  service: Service;
  company: Company;
  team?: Team;
  productXbz?: ProductXBZ;
  code: string;
  status: BudgetStatus;
  note?: string;
  product?: string;
  productMaterial?: string;
  productColor?: string;
  engravingText?: string;
  quantity?: number;
  price?: string;
  unitPrice?: string;
  createdAt: string;
  deletedAt?: string;
  createdBy?: string;
  size?: string;
  preset?: string;
  files?: any[]; // Adjust if there's a specific file model
};
